<template>
    <div id="upload">
        <transition name="fade">
            <Loading v-if="isLoading"/>
        </transition>
        <gotop/>
        <div class="content">
            <div class="container" @change="checkUploadFile">
                <h2 class="title2">旅平險要保書上傳</h2>
                <h3 class="blueTitle">本次投保保單資訊</h3>
                <p>親愛的 <span class="tlf_r_f1" id="assuredName">{{ maskName(applicantName) }} </span>先生/小姐 您好:</p>
                <div class="inline">
                    <div class="inputControl">
                        <div class="inputTitle">投保險種</div>
                        <input type="text" class="inputStyle noTouch" value="旅平險" readonly>
                    </div>
                    <div class="inputControl">
                        <div class="inputTitle">要保序號</div>
                        <select class="inputStyle arrow" :class="{ 'alert':check1 }" v-model="orderId"
                                @change="setBackPolicyDueTime">
                            <option value="" disabled>請選擇要保書</option>
                            <option v-for="(policy, index) in uploadList" :value="policy.id" :key="index">
                                {{ policy.applicationNo }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="online">

                    <div class="inputTitle">上傳期限</div>
                    <input type="text" class="inputStyle noTouch" :value="backPolicyDueTime" readonly>


                </div>
                <h3 class="blueTitle">請上傳要保書相關文件</h3>
                <p class="attentionTxt"><img src="noticemark.svg" class="attention" alt="notice"> 僅限本次投保的要保相關文件回傳，勿回傳不相關的檔案</p>
                <p class="attentionTxt"><img src="noticemark.svg" class="attention" alt="notice"> 可上傳的檔案格式：JPG、PNG、TIF、PDF，每一個檔案限4MB，總共可以上傳到20個檔案。</p>
                <div class="uploadArea">
                    <div v-for="(piece, key) in pieces" :key="key + reloadUpdateArea" class="uploadItem"
                         :class="{ 'alert':check2}">
                        <label :for="'fileUpload' + piece">
                            <div class="number">{{ piece }}</div>
                            <img :src="imgUrl[piece - 1]" alt="" class="uploadImg" v-if="imgUrl.length > piece - 1">
                            <span class="uploadName">
                                {{ uploadedFileName[key] }}
                                <span class="holder" v-if="uploadedFileName.length < piece">
                                    請選檔案或直接拍照
                                    <span class="appIDNO">(限要保序號:{{ applicationNo }})</span>
                                </span>
                            </span>
                            <input type="file" :id="'fileUpload' + piece" accept=".jpg, .jpeg, .png, .pdf, .tif , .pdf"
                                   @change="getFileName($event, key)">
                            <img src="../assets/uploadIcon.svg" alt="" v-if="imgUrl.length < piece">
                        </label>

                        <img src="../assets/trash.svg" alt="" v-if="imgUrl.length > piece - 1" @click="deleteFile(key)"
                             class="delete">

                    </div>
                </div>
                <div class="anotherBtn center">
                    <button type="button" @click="addPiece" id="uploadBtn"
                            class="addBeneficiary btn">新增上傳欄位 <img src="../assets/addBeneficiary.svg" alt="addBeneficiary">
                    </button>
                </div>
            </div>
        </div>
        <div class="btnArea">
            <div class="anotherBtn">
                <a class="btn confirm" @click="pageUploadFile">送出</a>
            </div>
        </div>
    </div>
</template>
<script>
import gotop from "@/components/gotop.vue";
import {postApi, uploadFile} from "@/utils/callApi";
import Loading from "@/components/loading.vue";
import moment from "moment";
import {popUp} from "@/utils/popUp";
import {onMounted, ref} from "vue";
import gtm from "@/utils/gtmDataLayer";
import {useRouter} from "vue-router";
import $ from 'jquery'
import apiConfig from "@/utils/apiConfig";
import Swal from "sweetalert2";

export default {
    name: "upload-page",
    components: {
        Loading,
        gotop
    },
    setup(){
        const router = useRouter() ;

        let jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
        let counter = 3;
        const files = [];
        let startCheck = false;

        const orderId = ref(sessionStorage.getItem('insTraOrderId') || "");
        const pieces = ref([1,2]);
        const uploadedFileName = ref([]);
        const imgUrl = ref([]);
        const uploadList = ref([]);
        const applicantName = ref("");
        const applicationNo = ref("");
        const backPolicyDueTime = ref("");
        const reloadUpdateArea = ref(0);
        const check1 = ref(false);
        const check2 = ref(false);
        const isLoading = ref(false);//loading

        const addPiece = () => {
            if (counter <= 20) {//TODO 可能會改小
                pieces.value.push(counter)
                counter++
            }
            if (counter >= 21) {
                $("#uploadBtn").hide()
            }
        }
        const getFileName = (event, key) => {
            var file = event.target.files[0];

            if (files[key] != null) {
                files[key] = file;
                uploadedFileName.value[key] = file.name;
                imgUrl.value[key] = window.URL.createObjectURL(file);
            } else {
                files.push(file);
                uploadedFileName.value.push(file.name);
                imgUrl.value.push(window.URL.createObjectURL(file));
            }
            reloadUpdateArea.value++;
        }
        const deleteFile = (key) => {
            files.splice(key, 1);
            uploadedFileName.value.splice(key, 1);
            imgUrl.value.splice(key, 1);
        }
        const checkLogin = () => {
            if (jwtInfo == null) {
                sessionStorage.setItem("fromPage", "upload");
                router.push("/login");
            } else {
               loadUploadPage();
            }
        }
        const loadUploadPage = () => {
            jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));

            postApi(apiConfig.getUploadList, jwtInfo.token)
                .then((response) => {
                    var getUploadListRes = response.data;
                    if (getUploadListRes.code === 200) {
                        if (getUploadListRes.data.length === 0) {
                            Swal.fire({
                                title: "無上傳清單",
                                showConfirmButton: false,
                                showCloseButton: true,
                                html: '<img src="infomark.svg" alt="info"><p>您沒有需要上傳的要保書</p>',
                            })
                        } else {
                            uploadList.value = getUploadListRes.data;
                            applicantName.value = getUploadListRes.data[0].applicantName;

                            if (orderId.value !== "") {
                                setBackPolicyDueTime()
                            }
                        }
                    } else {
                        Swal.fire({
                            title: "取得要保書清單錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg" alt="error"><p>' + getUploadListRes.message + '</p>',
                        })
                    }
                })
                .catch(() => {
                    isLoading.value = false;
                    Swal.fire({
                        title: "取得要保書清單錯誤",
                        showConfirmButton: false,
                        showCloseButton: true,
                        html: '<img src="error.svg" alt="error"><p>取得要保書清單連線錯誤</p>',
                    })
                })
        }
        const setBackPolicyDueTime = () => {
            var uploadObject = uploadList.value.find(upload => upload.id === orderId.value);
            if(uploadObject !== null){
                var localeDate = uploadObject.backPolicyDueTime;

                backPolicyDueTime.value = uploadObject.backPolicyDueTime ? moment(localeDate).format('YYYY-MM-DD HH:mm:ss') : "";
                applicantName.value = uploadObject.applicantName;
                applicationNo.value = uploadObject.applicationNo;
            }
        }
        const checkUploadFile = () => {
            if(startCheck){
                if (orderId.value === "") {

                    check1.value = true;
                } else {
                    check1.value = false;
                }

                if (files.length === 0) {
                    check2.value = true;
                } else {
                    check2.value = false;
                }
            }
        }
        const pageUploadFile = () => {
            startCheck = true;
            checkUploadFile();
            let checkFlag = 0;
            const errorMsg = [];
            if (check1.value) {
                checkFlag++;
                errorMsg.push('請選擇要保書')
            }

            if (check2.value) {
                checkFlag++;
                errorMsg.push('請上傳檔案')
            }

            //由後端阻擋
            // files.forEach(file => {
            //     console.log(file.size)
            //     if((file.size / 1024 / 1024) > 4){
            //         checkFlag++;
            //         errorMsg.push(file.name + '檔案大小超過4MB');
            //     }
            // });

            if (checkFlag === 0) {
                isLoading.value = true;

                const data = new FormData();
                data.append('orderId', orderId.value);
                files.forEach(file => {
                    data.append('file', file);
                })

                jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
                uploadFile(apiConfig.uploadPolicy, jwtInfo.token, data)
                    .then((response) => {
                        var uploadPolicyRes = response.data;

                        if (uploadPolicyRes.code === 200) {
                            isLoading.value = false;
                            const uploadStorage = {
                                applicantName: applicantName.value,
                                applicationNo: applicationNo.value,
                                fileCount: files.length,
                                uploadTime: moment().format('YYYY-MM-DD HH:mm:ss')
                            }
                            sessionStorage.setItem("uploadStorage", JSON.stringify(uploadStorage));
                            router.push("/upload_complete");
                        } else {
                            isLoading.value = false;
                            Swal.fire({
                                title: "上傳要保書錯誤",
                                showConfirmButton: false,
                                showCloseButton: true,
                                html: '<img src="error.svg" alt="error"><p>' + uploadPolicyRes.message + '</p>',
                            });
                        }
                    })
                    .catch(() => {
                        isLoading.value = false;
                        Swal.fire({
                            title: "上傳要保書錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg" alt="error"><p>上傳要保書連線錯誤</p>',
                        })
                    })
            } else {
                Swal.fire({
                    title: "填寫資料錯誤",
                    showConfirmButton: false,
                    showCloseButton: true,
                    html: '<img src="error.svg" alt="error"><p>' + errorMsg[0] + '</p>',
                }).then(function () {
                    $(".alertStr").remove();
                    $(".alert").parent().append("<p></p>");
                })
            }
        }
        const maskName = (name) => {
            const char = name.toString().split('');
            let maskName = "";
            char.forEach((c,i) =>{
                if(i === 1){
                    maskName = maskName + 'Ｏ'
                }else{
                    maskName = maskName + c;
                }
            });
            return maskName;
        }

        checkLogin();

        onMounted(()=>{
            popUp();//公告系統
            gtm.pageViewEvent();//新增pageViewEvent
        })

        return{
            orderId,pieces,uploadedFileName,imgUrl,uploadList,applicantName,applicationNo,backPolicyDueTime, reloadUpdateArea,
            check1, check2, isLoading,
            addPiece,getFileName,deleteFile,checkUploadFile,pageUploadFile,maskName,setBackPolicyDueTime
        }
    }
}
</script>

<style lang="scss">
#upload {
  @media screen and (max-width: $small) {
    font-size: 16px;
  }

  .content {
    p {
      margin: 5px 0;
    }

    @media screen and (max-width: $small) {
      margin: 120px auto 60px;
    }
  }

    .addBeneficiary {
        &.btn {
            background: #fff;
            border: 2px dashed $blue-700;
            color: $blue-700;
            font-size:21px;
            @media screen and (max-width: $small) {
              width: 47%;
              box-sizing: border-box;
              font-size: 15px;
            }
        }

    }

    .uploadItem {
        border: 1px solid $btnGray;
        border-radius: 30px;
        padding: 10px 0;
        box-sizing: border-box;
        margin: 15px 0;
        position: relative;
        display: flex;
        align-items: center;

        label {
            width: 100%;
            display: flex;
            align-items: center;
        }

        input[type=file] {
            width: 0.1px;
            height: 0.1px;
            opacity: 0;
            overflow: hidden;
            position: absolute;
            z-index: -1;
        }

        .number {
            width: 35px;
            height: 35px;
            border-radius: 35px;
            text-align: center;
            color: #fff;
            background: $blue-700;
            line-height: 35px;
            font-weight: bold;
            font-size: 20px;
            display: inline-block;
            margin: 0 10px;
            vertical-align: top;

            @media screen and (max-width: $small) {
                width: 10%;
            }
        }

        .uploadImg {
            margin: 0 20px;
            position: inherit;
            max-width: 100px;
            max-height: 100px;

            @media screen and (max-width: $small) {

                &+.uploadName {
                    width: 25%;
                }
            }
        }

        .uploadName {
            display: inline-block;
            margin-top: 5px;
            word-break: break-all;
            color:$textColor;
            @media screen and (max-width: $small) {
                font-size: 12px;
            }

            .holder {
                color: $btnGray;
                display: inline-block;
                margin: 0 15px;

                @media screen and (max-width: $small) {
                    font-size: 12px;
                    margin: 0;

                    .appIDNO {
                        display: block;
                    }
                }
            }
        }

        img {
            position: absolute;
            right: 15px;
            max-width: 70px;
            &.delete {
                z-index:999;
                cursor: pointer;
            }

            @media screen and (max-width: $small) {
                width: 65px;

                &.delete {
                    width: 25px;
                }
            }
        }
    }

    .uploadItem.alert {
        border: 2px solid $pink;
    }
    div:where(.swal2-container) .swal2-html-container{
        overflow:visible;
    }
}
</style>
